module.exports = __webpack_public_path__ + "media/images/home/icon_collapse_show-43b748b9698bdc14e086b72957f91739.svg";